import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo_home.png'


const _hoisted_1 = { class: "opModal stepModal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "form-group mt-4" }
const _hoisted_5 = { class: "privacyContainer" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "La tua email",
            text: "La tua email"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
          class: "form-control mt-2"
        }, null, 512), [
          [_vModelText, _ctx.mail]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$store.state.privacyAccepted) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.$store.state.privacyAccepted]
          ]),
          _createVNode(_component_localized_text, {
            localizedKey: "Andando avanti accetto le condizioni di privacy policy",
            text: "Andando avanti accetto le condizioni di <a href=\"https://www.taitu.it/privacy-policy/\" target=\"_blank\">privacy policy</a>",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.state.privacyAccepted = !_ctx.$store.state.privacyAccepted))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
          disabled: !_ctx.mail || !_ctx.$store.state.privacyAccepted
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Invia",
            text: "Invia"
          })
        ], 8, _hoisted_7)
      ])
    ])
  ]))
}